import React from 'react';
import DOMPurify from 'dompurify';
import MarkdownIt from 'markdown-it';
var markdownIt = new MarkdownIt();
export function renderMd(md) {
    if (typeof md !== 'string') {
        return md;
    }
    var html = markdownIt.render(md || '');
    return React.createElement("div", { dangerouslySetInnerHTML: { __html: DOMPurify.sanitize(html) } });
}
//# sourceMappingURL=renderMarkdown.js.map